import {
    PAYMENTS_SUCCESS,
    PAYMENTS_FAILED
} from '../actions/types';

const INITIAL_STATE = {
    transactions: [],
    showModal: false,
    error: ''
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case PAYMENTS_SUCCESS:
            return { 
                ...state,
                transactions: [...state.transactions, action.payload],
                showModal: true
            }
        case PAYMENTS_FAILED:
            return { 
                ...state, 
                error: 'Payment Failed.',
                showModal: true
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/paymentsReducer.js